export default __webpack_public_path__ + "static/media/star_empty.f69ca042.svg";